/* eslint-disable */
import React from 'react';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { ReactComponent as ClockSvg } from '../../assets/images/clockSvg.svg';
import { ReactComponent as FaceSvg } from '../../assets/images/face.svg';
import { ReactComponent as MenuSvg } from '../../assets/images/menu.svg';
import Button from 'src/onboarding/components/ui/button/Button';
import styles from './style.module.scss';
interface BenefitItem {
  icon: React.ReactNode;
  title: string;
  description: string;
}

function Page() {
  const { onNext, currentIndex } = useNav();
  const { prelandText } = useRemoteConfig();

  const benefits: BenefitItem[] = [
    {
      icon: <ClockSvg />,
      title: t('onboarding.preland.benefits.yourGoalTitle'),
      description: t('onboarding.preland.benefits.yourGoalDesc'),
    },
    {
      icon: <MenuSvg />,
      title: t('onboarding.preland.benefits.mealPlanTitle'),
      description: t('onboarding.preland.benefits.mealPlanDesc'),
    },
    {
      icon: <FaceSvg />,
      title: t('onboarding.preland.benefits.exactCalorieTitle'),
      description: t('onboarding.preland.benefits.exactCalorieDesc'),
    },
  ];

  return (
    <div className={'layout'}>
      <div className={styles.wrapperInfo}>
        <Title tag='h2' className={styles.title}>
          {prelandText.title}
        </Title>
        <Text size='m' medium className={styles.description}>
          {prelandText.subTitle}
        </Text>
      </div>

      <div className={'content'}>
        <div className={styles.services}>
          {benefits.map((benefit, index) => (
            <div className={styles.service} key={index}>
              <div style={{ width: 36 }}>{benefit.icon}</div>
              <div className={styles.serviceText}>
                <Text semibold>{benefit.title}</Text>
                <span>{benefit.description}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.continue}>
        <Button
          title={t('onboarding.preland.startQuiz')}
          onClick={() => {
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'preland',
            });
            onNext();
          }}
        />
      </div>
    </div>
  );
}
export default Page;
